import * as React from 'react';
import { observer } from 'mobx-react';

interface IIfProps {
	condition: boolean | undefined;
	children: React.ReactNode;
}

const If: React.FC<IIfProps> = ({ condition, children }) => {
	if (condition) {
		return <>{children}</>;
	}

	return null;
};

export default observer(If);
